"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.TimeContainer=exports.BannerAddress=void 0;const BannerAddress=exports.BannerAddress=_styledComponents.default.div`
  text-align: left;

  .address {
    font-weight: 800;
  }
`,TimeContainer=exports.TimeContainer=_styledComponents.default.div`
  text-align: left;
  display: flex;

  .sub-heading {
    font-weight: 800;
    padding: 0 !important;
    line-height: 20px;
  }
  
`;